const stats = [
  { icon: 'ri-article-line', value: '12,000+', label: '独家爆料', suffix: '' },
  { icon: 'ri-user-smile-line', value: '850万', label: '月活跃读者', suffix: '' },
  { icon: 'ri-fire-line', value: '99.7%', label: '信息准确率', suffix: '' },
  { icon: 'ri-global-line', value: '200+', label: '覆盖城市', suffix: '个' },
];

export default function Milestones() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-foreground-900">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 mb-4 text-xs font-label font-semibold text-accent-400 bg-accent-500/10 rounded-full">
            平台数据
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-background-50 mb-3">
            用数字说话
          </h2>
          <p className="text-sm md:text-base text-background-50/50 max-w-xl mx-auto">
            六年来，我们坚持产出高质量内容，赢得了数百万读者的信赖
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="text-center p-5 md:p-6 rounded-lg border border-background-50/10 bg-background-50/[0.03]"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 mx-auto mb-3 md:mb-4 rounded-full bg-primary-500/10 flex items-center justify-center">
                <i className={`${stat.icon} text-xl md:text-2xl text-primary-400`}></i>
              </div>
              <div className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-background-50 mb-1">
                {stat.value}
                {stat.suffix && (
                  <span className="text-sm md:text-base font-label font-normal text-background-50/50 ml-1">
                    {stat.suffix}
                  </span>
                )}
              </div>
              <p className="text-xs md:text-sm text-background-50/50 font-label">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}